<template>
<v-app id="registration-page">
    <cookie-law theme="blood-orange--rounded" 
                  buttonText="ACCETTO!">
                  <div slot="message">
                    QuickBe Utilizza cookie tecnici e di terze parti per fornirti il migliore servizio possible, 
                    puoi vedere in dettaglio cosa usiamo e come disabilitarlo da qui:
                    <router-link class="q-orange"
                      :title="getString('Uso dei cookies')"
                      to="/legal/cookie">Info Cookie
                    </router-link>
            </div>
      </cookie-law>
    <v-content style="margin-bottom:150px">
        <header-p></header-p>
        <section style="margin-top:30px">
            <v-layout row lg4 md10 sd12 xs12 align-center justify-center>
                <v-container>
                    <header id="top" style="margin:auto;max-width:900px">
                        <h1 style="font-size:40px;">Programmi di affiliazioni e scontistica</h1>

                        <h1 style="font-size:30px">1. CONDIZIONI D’USO PROGRAMMA D’AFFILIAZIONE PER UTENTE FINALE</h1>
                        <h2>1.1 Programmi</h2>
                        <p>QuickBe offre un programma di affiliazione su due livelli:</p>
                        <ul>
                            <li>Livello cliente</li>
                            <li>Livello commerciale</li>
                        </ul>
                        <h2>1.2 Affiliazione livello cliente</h2>
                        <p>L’affiliazione livello cliente funziona per gli utenti finali di QuickBe, ossia i clienti dei commercianti che usano QuickBe.</p>
                        <p>Il programma prevede l’assegnazione di un codice univoco <b>(CODICE DI SEGNALAZIONE)</b> per cliente che potrà essere utilizzato, tramite segnalazione del cliente stesso all’esercente, per la registrazione al servizio con le seguenti condizioni:</p>
                        <ol>
                            <li>Il <b>CODICE DI SEGNALAZIONE</b> è valido solo se l’esercente sottoscriverà un abbonamento di tipo SILVER o PLATINUM (quindi non sarà valido per la sottoscrizione FREE)</li>
                            <li>Il <b>CODICE DI SEGNALAZIONE</b> non è valido se l’esercente aveva già un qualsiasi tipo di abbonamento sottoscritto</li>
                            <li>Il <b>CODICE DI SEGNALAZIONE</b> può essere usato esclusivamente una volta per esercizio</li>
                            <li>Il <b>CODICE DI SEGNALAZIONE</b> può essere usato esclusivamente da un utente per esercizio</li>
                            <li>Il <b>CODICE DI SEGNALAZIONE</b> deve essere inoltrato insieme alla richiesta di registrazione, altrimenti non è valido</li>
                            <li>Il <b>CODICE DI SEGNALAZIONE</b> produrrà il buono sconto solo ed esclusivamente a transazione avvenuta, la spedizione del buono avverrà ad un massimo di 60 giorni dalla produzione dalla transazione</li>
                        </ol>
                        <p>Il <b>CODICE DI SEGNALZIONE</b> produrrà quindi un buono sconto monouso di <b>20€</b>, che segue le seguenti condizioni:</p>
                        <ol>
                            <li>Il <b>BUONO SCONTO</b> è usabile una sola volta</li>
                            <li>Il <b>BUONO SCONTO</b> ha una validità di 2 mesi a partire dall’erogazione (rimane comunque a discrezione dell’esercente l’accettazione del buono oltre la data di scadenza) e la data di scadenza sarà indicata su quest’ultimo</li>
                            <li>Il <b>BUONO SCONTO</b> sarà inviato all’email indicata durante il <b>PROCESSO DI AFFILIAZIONE</b></li>
                        </ol>
                        <p>L’esercente, nella segnalazione di un programma di affiliazione riceverà, se formulerà l’abbonamento semestrale o annuale, corrispettivamente uno sconto di 10€ e 20€.</p>
                        <p>Per ottenere il tuo codice di affiliazione vai <router-link class="a" to="/affil">{{getString('qui')}}</router-link>.
                        <h2>1.3 Affiliazione livello commerciale</h2>
                        <p>Sei un commerciale e vuoi conoscere le nostre proposte di affiliazione? Contattaci ad <a href="mailto:comm@quickbe.app">comm[at]quickbe.app </a> per valutare le nostre proposte.</p>

                        <h1 style="font-size:30px">2. CONDIZIONI D'USO BUONO SCONTO</h1>
                        <p>I buoni sconto possono essere erogati da Dew Studio e forniti a terzi (riviste, blog, commerciali) o forniti direttamente da noi.</p>
                        <p>I buoni sconto, oltre alle limitazioni che saranno fornite insieme ad esso nell’erogazione, avranno le seguenti condizioni:</p>
                        <ul>
                            <li><b>Dew Studio</b> si riserva il diritto di verificare la validità del BUONO SCONTO e conseguentemente di accettarlo o rigettarlo</li>
                            <li>Un BUONO SCONTO, se monouso, sarà validato secondo la cronologia d’uso</li>
                        </ul>
                    </header>
                </v-container>
            </v-layout>
            <v-layout column>
                <v-flex xs12 sm4 class="my-3">
                    <div class="text-xs-center">

                        <v-container>
                            <v-btn class="q-orange" @click="$router.push({path:'/'})">{{getString('Torna a ')}}{{appName}}</v-btn>
                        </v-container>
                    </div>
                </v-flex>
            </v-layout>
        </section>
    </v-content>
    <v-footer dark height="auto" class=".footer">
        <v-card class="flex" flat tile>
            <v-card-title class="q-orange-bk">
                <strong class="subheading">{{getString("Seguici sui social!")}}</strong>
                <v-spacer></v-spacer>
                <v-btn v-for="icon in icons" :key="icon.ic" class="mx-3" dark icon @click="navigate(icon.url)">
                    <v-icon size="24px">{{ icon.ic }}</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text class="grey darken-3 justify-center" style="text-align:center">
                &copy; 2018 - &copy;{{(new Date()).getFullYear()}} — &nbsp;<strong>Dew Studio </strong> &nbsp; — &nbsp;
                <a href="https://plaza.quickbe.app">{{getString('QuickBe Plaza')}}</a>&nbsp; — &nbsp;
                <router-link to="/legal/tec">{{getString('Trattamento dati')}}</router-link>&nbsp; — &nbsp;
                <router-link to="/legal/cookie">{{('Cookie Policy')}}</router-link>&nbsp; — &nbsp;
                <router-link to="/legal/eula">{{('Termini e condizioni')}}</router-link>&nbsp; — &nbsp;
                <router-link to="/admin/login">{{getString('Portale')}}</router-link>
            </v-card-text>
        </v-card>
    </v-footer>
</v-app>
</template>

<script>
import HeaderP from './Header'
import CookieLaw from "vue-cookie-law";
export default {
  name: 'LegalEULACoupon',
  components: {
        HeaderP,
        CookieLaw
    },
  data: () => {
    return {
      icons: [
        {
          ic: 'fab fa-facebook',
          url: 'https://www.facebook.com/QuickBeApp/'
        },
        {
          ic: 'fab fa-instagram',
          url: 'https://www.instagram.com/quickbeapp/'
        }
      ],
      appName: 'QuickBe'
    }
  },
  methods: {
    navigate: function(url) {
      window.open(url)
    },
    getString: function(key) {
      let page = this.$store.state.currentTranslator.getString(key)
      return page
    }
  }
}
</script>

<style scoped>
h2,
h3,
h4 {
  color: #d5725b;
}

.table {
  border: solid thin #999;
}

.table td {
  border: solid thin #999;
  padding: 5px 10px;
  margin: 0;
}

.table tr {
  border-right: none;
}
</style>



// WEBPACK FOOTER //
// src/components/frontend/LegalEULACoupon.vue